export { useOverlayTrigger } from '@react-aria/overlays';
//# sourceMappingURL=useOverlayTrigger.web.js.map